<template>
    <v-dialog
        v-model="modalProp"
        class="FormChangePass"
        max-width="500"
    >
        <v-card>
            <v-card-title
                class="text-h5 white lighten-2"
                style="text-align: center; display: block;position: relative; background-color: red; padding-bottom: 18px;"
            >
                Change Password
                <span
                    style="cursor: pointer; position: absolute; right: 30px; top: 16px; font-size: 15px; font-weight: 600; color: #009688;"
                    @click="modalProp = false"
                >Cancel</span>
            </v-card-title>
            <div style="padding: 10px;">
                <v-form
                    ref="form"
                    v-model="valid"
                    @submit.prevent="confirmChangePass"
                >
                    <v-text-field
                        v-model="password.old"
                        clearable
                        :append-icon="passwordShow.old ? mdiEye : mdiEyeOff"
                        :type="passwordShow.old ? 'text' : 'password'"
                        :rules="[(v) => !!v || 'Old Password is required']"
                        label="Current password"
                        :prepend-inner-icon="mdiLock"
                        color="#009688"
                        @click:append="passwordShow.old = !passwordShow.old"
                    />
                    <v-text-field
                        v-model="password.new"
                        clearable
                        :append-icon="passwordShow.new ? mdiEye : mdiEyeOff"
                        :type="passwordShow.new ? 'text' : 'password'"
                        :rules="[(v) => !!v || 'New Password is required'].concat(passRules)"
                        label="New password"
                        :prepend-inner-icon="mdiLockOutline"
                        color="#009688"
                        @click:append="passwordShow.new = !passwordShow.new"
                    />
                    <v-text-field
                        v-model="password.retype"
                        clearable
                        :append-icon="passwordShow.retype ? mdiEye : mdiEyeOff"
                        :type="passwordShow.retype ? 'text' : 'password'"
                        :rules="[(v) => !!v || 'Retype Password is required'].concat([(password.new === password.retype) || 'Password must match'])"
                        label="Re-type password"
                        :prepend-inner-icon="mdiLockOutline"
                        color="#009688"
                        @click:append="passwordShow.retype = !passwordShow.retype"
                    />
                    <v-btn
                        class="white--text"
                        :disabled="!valid"
                        rounded
                        style="display: block; width: 100%; background-color: #009688; color: white;"
                        type="submit"
                    >
                        change password
                    </v-btn>
                </v-form>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import UserCookie from 'vue-cookies'
import { mapActions, mapGetters } from 'vuex'
import {
    mdiEye,
    mdiEyeOff,
    mdiLock,
    mdiLockOutline
} from '@mdi/js'
export default {
    props: ['show'],
    data: ()=>({
        mdiEye,
        mdiEyeOff,
        mdiLock,
        mdiLockOutline,
        changepass: false,
        password: {
            old: null,
            new: null,
            retype: null
        },
        passwordShow: {
            old: false,
            new: false,
            retype: false
        },
        passRules: [(v) => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d!@#$%^&*()-_=+{};:,.<>?/\\|\[\]~]{8,}$/.test(v) || 'Must be at least 8 characters long with a mix of uppercase letters, lowercase letters, and numbers.'],
        valid: false
    }),
    computed: {
        ...mapGetters(['changePass', 'changePasswordAdminData']),
        modalProp: {
            get() {
                return this.show
            },
            set() {
                this.$nextTick(() => {
                    if (this.$refs.form) this.$refs.form.reset()
                })
                this.$emit('closeChangePass')
            }
        }
    },
    watch: {
        changePasswordAdminData(newVal) {
            if (newVal) {
                setTimeout(()=>{
                    this.$emit('msgChangePass', newVal)
                }, 300)
                if (newVal.data) this.modalProp = false
            }
        }
    },
    methods: {
        ...mapActions(['getCsrfToken','changePassword', 'changePasswordAdmin']),
        async confirmChangePass() {
            if (this.$refs.form.validate()) {
                const ID        = UserCookie.get('admin_id') ? parseInt(UserCookie.get('admin_id')) : null
                const OLD_PASS  = this.password.old
                const NEW_PASS  = this.password.new
                const params    = { ID, OLD_PASS, NEW_PASS }
                // await this.getCsrfToken()
                await this.changePasswordAdmin(params)
            }
        }
    }
}
</script>

<style scoped>
.userCredentials {
        margin: 0 auto;
        padding: 0 30px;
    }
        .userCredentials tr {
            /* background-color: green; */
        }
        .firstShowCred td {
            padding-top: 10px;
            padding-bottom: 10px;
        }
        .labelManageAccount {
            /* background-color: blue; */
            padding: 12px;
            text-align: right;
            font-weight: 500;
        }
            .fieldManageAccont {
                /* background-color: orange; */
                padding-top: 25px;
            }
</style>
